module.exports = __webpack_public_path__ + "img/icon2.309bb552.png";